export default {
    async saveModeloPush ({getters}, template)
    {
        let {data} = await getters.getApi.post("templatePush", template)
        return data
    },

    async updateModeloPush ({getters}, template)
    {
        let {data} = await getters.getApi.put("templatePush", template)
        return data
    },

    async listaModelos ({commit, getters})
    {
        let {data} = await getters.getApi.get("templatePush")
        commit('SET_MODELOS_TEMPLATE', data.data)
        return data
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/push/actions.js